module.exports = __webpack_public_path__ + "img/united-kingdom.e0f482b6.svg";